// 参与人员列表面板
import styled from "@emotion/styled";
import React from "react";
import { Input, Paper } from "@mui/material";
import classNames from "classnames";
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from "@mui/icons-material/MicOff";
import MicNoneIcon from '@mui/icons-material/MicNone'

const EmoUserListPanel = styled.div`
  max-height: 200px;
  display: flex;
  flex-flow: column;
  overflow-y: auto;
  font-size: 12px;
  pointer-events: auto;
`
const EmoUserListItem = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  padding: 4px 0;
  pointer-events: auto;
  
  > span {
    display: flex;
  }
  
  & > .role {
    padding-left: 4px;
    padding-right: 4px;
    border-radius: 2px;
    background-color: #5a6268;
    color: white;
  }

  & > .self-tag {
    color: darkorange;
  }
  
  & > .nickname {
    color: white;
  }

  & > .nickname.self-name {
    color: greenyellow;
  }

  & > .btn {
    color: darkorange;
    cursor: pointer;
  }

  & > .edit-btn-groups {
    display: inline-flex;
  }

  & > .status {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #5a6268;

    &.online {
      background-color: aquamarine;
    }
  }
`

const UserInfoPanel = (props) => {
	const [showEditNickNameBox, setShowEditNickNameBox] = React.useState(false)
	const nickNameRef = React.createRef()
	
	//  麦克风开关还未更新，先禁用。
	const renderUserList = (userInfo, index) => {
		const { id, micro_status, current_ws_online, permission, extension, user_role } = userInfo
		const isSelf = id === props.selfInfo.id
		const canKickOut = !isSelf && current_ws_online && permission?.change_other_status
		const volumeItem = props.volumeLists.find(item => id === item.id)
		const isTalking = !!(volumeItem && volumeItem.audioVolume >= 10)
		let userRole = ''
		if(user_role === 'anchor') userRole = '主持人'
		else if (user_role === 'audience') userRole = '观众'
		
		return (
			<EmoUserListItem className="user-list-item" key={index}>
				<span onClick={() => props.onForbiddenMicro(id)}>
                    <Paper sx={{
	                    display: 'flex',
	                    marginRight: '2px'
                    }}>
                        { isTalking ? <MicIcon fontSize="small" color='primary'/> : micro_status ? <MicNoneIcon fontSize="small" /> : <MicOffIcon fontSize="small" /> }
                    </Paper>
                </span>
				<span className='role'>{userRole}</span>
				{isSelf && <span className="self-tag">[自己]</span>}
				{isSelf && showEditNickNameBox
					? <Input className='nickname'
                        autoFocus={true}
                        defaultValue=''
                        type='text'
                        inputRef={nickNameRef} />
					: <span className={classNames('nickname', {"self-name": isSelf})}>{extension?.nickname || id}</span>}
				<span className={classNames('status', {online: current_ws_online})} />
				{isSelf && !showEditNickNameBox && <span onClick={() => setShowEditNickNameBox(true)} className="edit-nickname btn">[修改昵称]</span>}
				{isSelf && showEditNickNameBox && <span className='edit-btn-groups btn'>
			                <span onClick={() => {
				                setShowEditNickNameBox(false)
				                props.onNickNameChange(nickNameRef.current?.value)
			                }} className="submit-nickname btn">[提交修改]</span>
			                <span onClick={() => setShowEditNickNameBox(false)} className="exit-edit-nickname btn">[退出]</span>
		                </span>}
				{canKickOut && <span onClick={() => props.onKickUser(id)}>
                    <Paper sx={{ display: 'flex', marginLeft: '2px' }}>
                        <PersonRemoveIcon fontSize="small"/>
                    </Paper>
                </span>}
			</EmoUserListItem>
		)
	}
	
	return (
		<div className="user-info">
			<EmoUserListPanel className="user-list-panel">
				{props.list && props.list.map((item, index) => renderUserList(item, index))}
			</EmoUserListPanel>
		</div>
	)
}

export default UserInfoPanel
